<div>
    <angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="htmlContent"></angular-editor>
</div>

<div>{{htmlContent|json}}</div>